import { render } from "./loadArea.vue?vue&type=template&id=54e48f83"
import script from "./loadArea.vue?vue&type=script&lang=js"
export * from "./loadArea.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__